import { useQueries } from "@tanstack/react-query";
import { activityKeys } from "PFCore/hooks/queries/activity/query_keys";
import { fetchActivity } from "PFCore/services/activities";
import { Activity, Id, QueryOptions } from "PFTypes";

export const useActivitiesQueries = (
  activityIds: Id[],
  options: QueryOptions<Activity, unknown, Activity> = {}
) => {
  const queries = useQueries({
    queries: activityIds.map((activityId) => ({
      queryKey: activityKeys.activity(activityId),
      queryFn: () => fetchActivity(activityId),
      retry: false,
      staleTime: 0,
      ...options
    }))
  });

  const isFetching = queries.some((query) => query.isFetching);

  return { queries, isFetching };
};
